import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import "./style.css";
import { handleLogout } from "../../utils/authUtils";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogoutClick = (event) => {
    event.preventDefault(); // Prevent default Link navigation
    handleLogout(navigate);
  };

  return (
    <>
      <ToastContainer />
      <Navbar className="navbar-custom ">
        <Container>
          {/* Sidebar Toggle Button */}
          {/* <Nav.Link
            className="nav-link-custom m-2"
            as={Link}
            to="#"
            onClick={toggleSidebar}
          >
            +
          </Nav.Link> */}

          <Navbar.Brand className="navbar-brand-custom" as={Link} to="/">
            <img src="/logo.png" alt="Main logo" />
          </Navbar.Brand>

          {/* Desktop Navigation */}
          {/* <Nav className="me-auto d-none d-lg-flex">
            <Nav.Link className="nav-link-custom" as={Link} to="/">
              Home
            </Nav.Link>
            <Nav.Link className="nav-link-custom" as={Link} to="/about">
              About
            </Nav.Link>
            <Nav.Link className="nav-link-custom" as={Link} to="/contact">
              Contact
            </Nav.Link>
          </Nav> */}

          {/* Right side of the header */}
          <Nav className="auth-nav d-flex align-items-center gap-3">
            <Nav.Link
              className="nav-link-custom p-0"
              as={Link}
              to="/invoice/create"
            >
              <button className="primary-button">Créer un devis</button>
            </Nav.Link>

            <Link onClick={handleLogoutClick}>
              <img src="/user_icon.png" alt="user" width="44px" />
            </Link>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar (Conditionally Rendered) */}
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />

      {/* Bottom Navigation for Mobile */}
      {/* <div className="bottom-nav d-lg-none  shadow-lg">
        <Row className="text-center ">
          <Col>
            <Link className="d-flex flex-column align-items-center dashboard_link">
              <div className="icon_wrapper">
                <img
                  src="./bottom_nav/Layout.png"
                  alt="dashboard"
                  className="dashboard_icon"
                />
              </div>
              <span style={{ paddingTop: "15px" }}>Dashboard</span>
            </Link>
          </Col>
          <Col className="position-relative ">
            <div
              className="plus_icon position-absolute top-0 start-50 translate-middle rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px" }}
            >
              <img src="./bottom_nav/plus.png" alt="plus"></img>
            </div>
            <span
              className="d-block text-secondary text-nowrap"
              style={{ paddingTop: "40px" }}
            >
              Créer un devis
            </span>
          </Col>
          <Col>
            <div className="d-flex flex-column align-items-center">
              <img
                src="./bottom_nav/Document.png"
                alt="documents"
                className="document_icon"
              />
              <span className="text-secondary " style={{ paddingTop: "16px" }}>
                Mes devis
              </span>
            </div>
          </Col>
        </Row>
      </div> */}

      <div className="bottom-nav d-lg-none shadow-lg">
        <Row className="text-center ">
          <Nav.Link className="nav-link-custom" as={Link} to="/invoice/create">
            <button className="primary-button">Créer un devis</button>
          </Nav.Link>
        </Row>
      </div>

    </>
  );
};

export default Header;
